var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNftFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75,7C20.75,4.93 19.07,3.25 17,3.25L7,3.25C4.93,3.25 3.25,4.93 3.25,7L3.25,17C3.25,19.07 4.93,20.75 7,20.75L17,20.75C19.07,20.75 20.75,19.07 20.75,17L20.75,7ZM15.061,14L16.53,15.47C16.823,15.762 16.823,16.238 16.53,16.53C16.238,16.823 15.762,16.823 15.47,16.53C15.47,16.53 10.476,11.536 10.473,11.534C10.17,11.244 9.839,11.081 9.5,11.081C9.16,11.081 8.829,11.245 8.524,11.536L4.75,15.311L4.75,17C4.75,18.242 5.758,19.25 7,19.25C7,19.25 17,19.25 17,19.25C18.242,19.25 19.25,18.242 19.25,17L19.25,15.311C18.732,14.792 17.475,13.536 17.473,13.534C17.17,13.244 16.839,13.081 16.5,13.081C16.16,13.081 15.829,13.245 15.524,13.536L15.061,14ZM15.005,7.25C15.419,7.25 15.755,7.586 15.755,8C15.755,8.414 15.419,8.75 15.005,8.75C14.591,8.75 14.255,8.414 14.255,8C14.255,7.586 14.591,7.25 15.005,7.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftFilled);
export default __webpack_public_path__ + "static/media/NFT_filled.afc624aa.svg";
export { ForwardRef as ReactComponent };